module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEeSURBVEhL7ZG/SsNQHEYjBTc36dChj+Ds4OhblLZvYsEH0CewL1CELh3q0iEtDTgLImRxERyMSN00epL7NaZNpCE3dMqBj9z8/pybUqdm74RhuCBzvVYDwhlZRucf4OzGjaqQ1Fuf42KVpKWVX4CvEUn5BU/kQ+cjte1BdhlJ01Abqm0Psld507yrbQ8XPEqaQM1X257tC3j/Jh217UB0Im8CtVO17cB1gGxqtAbeV2rbgSuSXxntH9QCjZQHSZOM5NyAevk/l+UWGZBAvgz0xhovBjttlvpkQr6M5n+Y6Wk1H2aOGeqSG+KbtWIw7/E4lCoLA7dk51fmwd4daUqVD3NnDF3oIpc8kBfypsSX8/wkz+SeXFM6l6KmDI7zC0HeFTpfdoSJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-slug/light/24.png
// module id = 2440
// module chunks = 2